import { months_dictionary } from '../../dictionaries/months_dictionary.js';

export const initData = {
  mal: {
    title: 'Малый бизнес',
    cards: [
      {
        title: 'Численность занятых',
        value: 485.3,
        measure: 'человек',
        date: `${
          months_dictionary[new Date().getMonth() + 1]
        } ${new Date().getFullYear()}`,
        percent: 10,
        type: 'positive',
        subCategory: 'people',
      },
      {
        title: 'Уплаченных налогов',
        value: 1563.5,
        measure: ' тенге',
        date: `${
          months_dictionary[new Date().getMonth() + 1]
        } ${new Date().getFullYear()}`,
        percent: 5,
        type: 'positive',
        subCategory: 'taxes',
      },
    ],
  },
  sred: {
    title: 'Средний бизнес',
    cards: [
      {
        title: 'Действующих компаний',
        value: 560,
        measure: '',
        date: `${
          months_dictionary[new Date().getMonth() + 1]
        } ${new Date().getFullYear()}`,
        percent: 10,
        type: 'negative',
        subCategory: 'medium_companies',
        quarter: true,
        breakWord: true,
      },
    ],
  },
  businessClimate: {
    // title: 'Независимый опрос НПП',
    title: 'Независимый рейтинг «Деловой климат»',
    cards: [
      {
        header: 'Малый бизнес',
        // title: 'Оценка эффективности деятельности МИО',
        title: null,
        value: 0,
        measure: 'из 4 баллов',
        date: '1 кв. 2024',
        percent: 0,
        type: 'positive',
        subCategory: 'business_inspections',
        showInfo: true,
      },
      {
        header: 'Средний бизнес',
        // title: 'Оценка эффективности деятельности МИО',
        title: null,
        value: 0,
        measure: 'из 4 баллов',
        date: '1 кв. 2024',
        percent: 0,
        type: 'positive',
        subCategory: 'mio_performance',
        showInfo: true,
      },
      // {
      //   title: 'Количество проверок бизнеса',
      //   value: 3.5,
      //   measure: 'баллов',
      //   date: '3 кв. 2023',
      //   percent: '',
      //   type: 'positive',
      //   subCategory: 'business_inspections',
      // },
    ],
  },
  projectsRealisation: {
    title: 'Инвест проекты',
    cards: [
      {
        title: 'Количество проектов',
        value: 800,
        measure: '',
        date: `${
          months_dictionary[new Date().getMonth() + 1]
        } ${new Date().getFullYear()}`,
        percent: 1,
        type: 'positive',
        subCategory: 'projectCount',
        projectsButton: true,
        dashboardButton: true,
      },
      // {
      //   title: 'Количество проектов без отставаний',
      //   value: 440,
      //   measure: 'единиц',
      //   date: 'ноябрь 2023',
      //   percent: 1,
      //   type: 'positive',
      //   subCategory: 'normalProjSum',
      // },
      // {
      //   title: 'Количество проектов с отставаниями',
      //   value: 100,
      //   measure: 'единиц',
      //   date: 'ноябрь 2023',
      //   percent: 1,
      //   type: 'negative',
      //   subCategory: 'delayedProjSum',
      // },
      {
        title: 'Проблемных проектов',
        value: 260,
        measure: '',
        date: `${
          months_dictionary[new Date().getMonth() + 1]
        } ${new Date().getFullYear()}`,
        percent: 10,
        type: 'negative',
        subCategory: 'problemProjects',
        projectsButton: true,
        showInfo: true,
      },
    ],
  },
  otp: {
    title: null,
    cards: [
      {
        title: 'Количество предприятий',
        value: 485.3,
        measure: '',
        date: `${
          months_dictionary[new Date().getMonth() + 1]
        } ${new Date().getFullYear()}`,
        percent: 10,
        type: 'positive',
        subCategory: 'otp_count',
        otpModal: true,
      },
      {
        title: 'Ср. загруженность предприятий',
        value: 0,
        measure: '%',
        date: `${
          months_dictionary[new Date().getMonth() + 1]
        } ${new Date().getFullYear()}`,
        percent: 5,
        type: 'positive',
        subCategory: 'otp_avg_workload',
      },
    ],
  },
  cluster: {
    title: 'Приоритетные отраслевые ниши',
    cards: [
      {
        title: 'Стратегия',
        type: 'positive',
        subCategory: 'development_program',
        items: [
          {
            title: 'Проектная команда',
            type: 'project_team',
          },
          {
            title: 'Модель отрасли',
            type: 'business_model',
          },
          {
            title: 'Целевые показатели',
            type: 'target_indicators',
          },
        ],
      },
      {
        title: 'Проблемные вопросы',
        type: 'positive',
        subCategory: 'top_problems',
        questions: {
          unresolved: 7,
          in_progress: 3,
          resolved: 2,
        },
        progressItems: [
          {
            total: 5,
            current: 4,
            title: 'Системные',
          },
          {
            total: 5,
            current: 3,
            title: 'Текущие',
          },
        ],
      },
    ],
  },
};
